export default "__VITE_ASSET__BqvNb2YR__"